import React, {useState} from "react";
import {TabMenu} from "primereact/tabmenu";
import {Button} from "primereact/button";
import AboutMe from "./AboutMe";
import Education from "./Education";
import ResearchInterest from "./ResearchInterest";
import Publications from "./Publications";
import Contact from "./Contact";
import {Terminal} from "primereact/terminal";
import {TerminalService} from "primereact/terminalservice";

export const Menu = () => {
  const [activeIndex, setActiveIndex] = useState(3);

  const items = [
    {label: "About Me", icon: "pi pi-fw pi-user"},
    {label: "Education", icon: "pi pi-fw pi-id-card"},
    {label: "Research Interest", icon: "pi pi-fw pi-pencil"},
    {label: "Publications", icon: "pi pi-fw pi-file"},
    {label: "Contact", icon: "pi pi-fw pi-phone"},
  ];

  return (
    <div>
      <h5>Dr. Muhammet Serkan ÇINAR</h5>
      <TabMenu
        model={items}
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        style={{width: "100vw"}}
      />
      {activeIndex === 0 && <AboutMe></AboutMe>}
      {activeIndex === 1 && <Education></Education>}
      {activeIndex === 2 && <ResearchInterest></ResearchInterest>}
      {activeIndex === 3 && <Publications></Publications>}
      {activeIndex === 4 && <Contact></Contact>}
    </div>
  );
};
